import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import LopBanDoApi from '../../api/LopBanDoApi';
import Select from 'react-select';
import QuanHuyenApi from '../../api/QuanHuyenApi';
import Pagination from 'react-bootstrap-4-pagination';
import Authen from '../../core/Authen';

export const LopBanDo = () => {
    const [listLopBanDos, setLopBanDo] = useState([]);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const { register, handleSubmit, reset } = useForm();
    const [filter, setFilter] = useState('');
    const [listQuanHuyens, setQuanHuyen] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');
    const [selectedOptionLopBanDo, setSelectedOptionLopBanDo] = useState('');

    const [nhanVien,setNhanVien] = useState({});
    const [roleAdd, setRoleAdd] = useState(false);
    const [roleEdit, setRoleEdit] = useState(false);
    const [roleDel, setRoleDel] = useState(false);

    const listOptionLopBanDo = [
    { value: '', label: 'Chọn lớp bản đồ' },
    { value: '1', label: 'Lớp nền' },
    { value: '2', label: 'Lớp thổ nhưỡng' },
    { value: '3', label: 'Lớp bản đồ chất lượng đất' },
    { value: '4', label: 'Lớp bản đồ mức độ thích hợp' },
    { value: '5', label: 'Lớp bản đồ đề xuất sử dụng đất' }];

    let pageIndex = 1;
    let pageSize = 20;
    const [paginationConfig, setPaging] = useState({
        totalPages: 1,
        currentPage: 1,
        showMax: 5,
        size: "sm",
        threeDots: true,
        prevNext: true,
        center: true,
        onClick: function (page) {
            pageIndex = page;
            loadLopBanDo();
        }
    });

    const loadLopBanDo = async () => {
        try {
            const params = {
                pageIndex: pageIndex,
                pageSize: pageSize,
                keyword: filter,
                idQuanHuyen: ''
            }
            const response = await LopBanDoApi.getPaging(params);
            response.Items.forEach(item => {
                item.Checked = false;
            });
            paginationConfig.totalPages = Math.ceil(response.TotalRow/ pageSize);
            paginationConfig.currentPage = pageIndex;
            setPaging(paginationConfig);
            setLopBanDo(response.Items);
        } catch (err) {
        }
    }

    useEffect(() => {
        loadLopBanDo();
        loadQuanHuyen();
        setNhanVien(Authen.getUser());
        setRoleAdd(Authen.checkQuyen('LOPBANDO_CREATE'));
        setRoleEdit(Authen.checkQuyen('LOPBANDO_UPDATE'));
        setRoleDel(Authen.checkQuyen('LOPBANDO_DELETE'));
    }, []);


    const timKiem = () => {
        loadLopBanDo();
    }

    function onChangeFilter(e) {
        setFilter(e.target.value)
    }

    const saveData = (data) => {
        if(selectedOption.value){
            data.IdQuanHuyen = selectedOption.value;
        }
        data.Type = selectedOptionLopBanDo.value;
        data.CreatedBy = nhanVien.Id;
        if(data.GeoJson)
        data.GeoJson=1;
        else
        data.GeoJson=0;
       
        if (data.Id === "0") {
            LopBanDoApi.post(data).then(() => {
                setShow(false);
                loadLopBanDo();
            })
        }
        else {
            LopBanDoApi.put(data).then(() => {
                setShow(false);
                loadLopBanDo();
            })
        }
    }

    const clickRow = (id) => {
        listLopBanDos.forEach(item => {
            if (item.Id === id) {
                item.Checked = !item.Checked;
            }
        });
        setLopBanDo([...listLopBanDos]);
    }

    const handleShowAdd = () => {
        reset({
            Id: 0,
            Name: null
        }, [reset]);
        setShow(true)
    };

    const handleShowEdit = () => {
        let index = listLopBanDos.findIndex(x => x.Checked);
        if (index !== -1) {
            LopBanDoApi.getDetail(listLopBanDos[index].Id).then((response) => {
                reset({
                    Id: response.Id,
                    Name: response.Name,
                    LayerName: response.LayerName,
                    SortOrder: response.SortOrder,
                    Url: response.Url,
                    IdQuanHuyen: response.IdQuanHuyen,
                    Ratio: response.Ratio,
                    Type: response.Type,
                    Checked: response.Checked,
                    GeoJson: response.GeoJson
                }, [reset])
                setShow(true);
                let index = listQuanHuyens.findIndex(x=>x.value == response.IdQuanHuyen);
                let indexLopBanDo = listOptionLopBanDo.findIndex(x=>x.value == response.Type);
                setSelectedOption(listQuanHuyens[index]);
                setSelectedOptionLopBanDo(listOptionLopBanDo[indexLopBanDo]);
            });
        }
    }

    const handleShowDel = () => {
        let index = listLopBanDos.findIndex(x => x.Checked);
        if (index !== -1) {
            LopBanDoApi.delete(listLopBanDos[index].Id).then(() => {
                loadLopBanDo();
            })
        }
    }

    const checkBoHandler = () => {

    }

    const onChangeQuanHuyen = (event) =>{
        setSelectedOption(event);
    }

    const onChangeLopBanDo = (event) =>{
        setSelectedOptionLopBanDo(event);
    }

    function loadQuanHuyen() {
        QuanHuyenApi.getAll().then((response) => {
            let list = [];
            list.push({ value: '', label: 'Chọn huyện' });
            response.forEach(item => {
                list.push({ value: item.Id, label: item.Ten });
            })
            setQuanHuyen(list);
        })
    }



    return (
        <div className="card shadow mb-1">
            <div className="card-header py-2 row">
                <div className="col-md-4">
                    <h6 className="m-0 font-weight-bold text-primary">Lớp bản đồ</h6>
                </div>
                <div className="input-group col-md-4">
                    <input type="text" className="form-control" placeholder="Tìm kiếm" value={filter} onChange={onChangeFilter} />
                    <div className="input-group-append">
                        <button className="btn btn-info" type="button" onClick={timKiem}><i className='fas fa-search'></i> Tìm kiếm</button>
                    </div>
                </div>
                <div className="col-md-4 bd-button text-right">
                    {roleEdit == true ?<Button variant="success" size="sm" onClick={handleShowAdd}><i className='fas fa-plus'></i> Thêm</Button>:''}
                    {roleEdit == true ?<Button variant="primary" size="sm" onClick={handleShowEdit}><i className='fas fa-edit'></i> Sửa</Button>:''}
                    {roleEdit == true ?<Button variant="danger" size="sm" onClick={handleShowDel}><i className='fas fa-trash-alt'></i> Xóa</Button>:''}
                </div>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <table className="table table-bordered" width="100%">
                        <thead>
                            <tr>
                                <th className="col-checkbox"></th>
                                <th>Tên</th>
                                <th>Lớp bản đồ</th>
                                <th>Thứ tự</th>
                                <th>Huyện</th>
                                <th>Kiểu lớp</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listLopBanDos.map((item, key) => {
                                    return (
                                        <tr onClick={() => clickRow(item.Id)} key={key}>
                                            <td className="col-checkbox">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" checked={item.Checked} onChange={checkBoHandler} />
                                                </div>
                                            </td>
                                            <td>{item.Name}</td>
                                            <td>{item.LayerName}</td>
                                            <td>{item.SortOrder}</td>
                                            <td>{item.TenQuanHuyen}</td>
                                            <td className="text-center">{console.log(item), item.Type===1?"Lớp nền":
                                            (item.Type===2?"Lớp thổ nhưỡng":
                                            (item.Type===3?"Lớp bản đồ chất lượng đất":
                                            (item.Type===4?"Lớp bản đồ mức độ thích hợp":
                                            "Lớp bản đồ đề xuất sử dụng đất")))}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className="col-md-12 phan-trang">
                <Pagination {...paginationConfig} />
                </div>
            </div>

            <Modal show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Lớp bản đồ</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="user" onSubmit={handleSubmit(saveData)}>
                        <input name="Id" hidden={true} ref={register}></input>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Tên</label>
                            <div className="col-sm-9">
                                <input name="Name" type="text" className="form-control" placeholder="Tên lớp" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Lớp bản đồ</label>
                            <div className="col-sm-9">
                                <input name="LayerName" type="text" className="form-control" placeholder="Lớp bản đồ" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Đường dẫn</label>
                            <div className="col-sm-9">
                                <input name="Url" type="text" className="form-control" placeholder="Đường dẫn" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Phiên bản</label>
                            <div className="col-sm-9">
                                <input name="Version" type="text" className="form-control" placeholder="Phiên bản" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Huyện</label>
                            <div className="col-sm-9">
                                <Select
                                    className="select"
                                    name="IdQuanHuyen"
                                    placeholder="Quận huyện"
                                    value={selectedOption}
                                    onChange={onChangeQuanHuyen}
                                    options={listQuanHuyens}
                                    theme={theme => ({
                                        ...theme,
                                        borderRadius: 0,
                                        height: 30,
                                        spacing: {
                                            controlHeight: 30,
                                            menuGutter: 1,
                                            baseUnit: 2,
                                        }
                                    })}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Thứ tự</label>
                            <div className="col-sm-9">
                                <input name="SortOrder" type="text" className="form-control" placeholder="Thứ tự" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Ratio</label>
                            <div className="col-sm-9">
                                <input name="Ratio" type="text" className="form-control" placeholder="Ratio" ref={register} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Kiểu lớp</label>
            
                            <div className="col-sm-9">
                                <Select
                                    className="select"
                                    name="Type"
                                    placeholder="Lớp bản đồ"
                                    value={selectedOptionLopBanDo}
                                    onChange={onChangeLopBanDo}
                                    options={listOptionLopBanDo}
                                    theme={theme => ({
                                        ...theme,
                                        borderRadius: 0,
                                        height: 30,
                                        spacing: {
                                            controlHeight: 30,
                                            menuGutter: 1,
                                            baseUnit: 2,
                                        }
                                    })}
                                />
                            </div>

                        </div>
                        <div className="form-group row">
                            <label className="col-sm-3 col-form-label">Hiển thị</label>
                            <div className="col-sm-2">
                                <input name="Checked" type="Checkbox" className="form-control" ref={register} />
                            </div>
                            <div className='col-sm-2'></div>
                            <label className="col-sm-3 col-form-label">Kiểu UrlGeoJson</label>
                            <div className="col-sm-2">
                                <input name="GeoJson" type="Checkbox" className="form-control" ref={register} />
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" size="sm" onClick={handleSubmit(saveData)}><i className='fas fa-save'></i> Lưu</Button>
                    <Button variant="danger" size="sm" onClick={handleClose}><i className="fas fa-sign-out-alt"></i> Hủy</Button>
                </Modal.Footer>
            </Modal>

        </div>

    )
}
